import { render, staticRenderFns } from "./CloverList--Cards.vue?vue&type=template&id=27fd48bb&lang=pug&"
import script from "./CloverList--Cards.vue?vue&type=script&lang=js&"
export * from "./CloverList--Cards.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports